import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from '../common.service';
var CasePracticeCoachComponent = (function () {
    function CasePracticeCoachComponent(route, router, commonService, apiService) {
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.apiService = apiService;
    }
    CasePracticeCoachComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSeperateModel = false;
        this.sub = this.route.params.subscribe(function (params) {
            _this.learningPathId = params['learningPathId'];
            /*this.practiceId = params['practiceId'];*/
            _this.practiceMetaId = params['practiceMetaId'];
            _this.exerciseId = params['exerciseId'];
            /*if (this.practiceId > 0) {
                this.page = "main";
                this.getPractice();
            }
            else if (this.practiceMetaId > 0) {
                this.isSeperateModel = true;
                this.getPracticeByPracticeMetaId();
            }
            else {
                this.page = "begin";
            }*/
            if (_this.exerciseId > 0) {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/api/exercises/' + _this.exerciseId
                }).subscribe(function (result) {
                    _this.currentCase = result;
                    _this.page = 'main';
                });
            }
            else {
                _this.page = 'list';
            }
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/' + _this.learningPathId + '/' + _this.practiceMetaId + '/createAndGet'
            }).subscribe(function (result) {
                _this.practiceList = result.exercise;
                _this.practiceId = result.id;
                // that.apiService.ajax({
                //   'type':'get',
                //   'url':'/api/exercises/'+that.practiceList[that.index].id
                // }).subscribe(result=>{
                //   that.currentCase = result;
                //   that.page = 'main';
                // });
            });
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/getUserInfo',
                'data': {}
            }).subscribe(function (result) {
                _this.status = result;
            });
            /*this.practiceList = this.getMockData().exercise;
            this.practiceId = this.getMockData().id;
            this.status = 2;*/
        });
    };
    CasePracticeCoachComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    CasePracticeCoachComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    CasePracticeCoachComponent.prototype.goToExercise = function (i) {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/exercises/' + this.practiceList[i].id
        }).subscribe(function (result) {
            _this.currentCase = result;
            _this.page = 'main';
        });
    };
    CasePracticeCoachComponent.prototype.createPractice = function () {
        var _this = this;
        this.apiService.createPractice("" + this.learningPathId + "").subscribe(function (practice) {
            _this.practice = practice;
            _this.practiceId = practice.id;
        });
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/getUserInfo',
            'data': {}
        }).subscribe(function (result) {
            _this.status = result;
        });
    };
    CasePracticeCoachComponent.prototype.getPractice = function () {
        var _this = this;
        this.apiService.getPractice("" + this.practiceId + "").subscribe(function (practice) {
            _this.practice = practice;
            _this.page = "main";
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/getUserInfo',
                'data': {}
            }).subscribe(function (result) {
                _this.status = result;
                if (!_this.practice.currentCase && _this.status == 1 || _this.status != 1 && _this.practice.progress >= 49 && _this.practice.progress <= 51) {
                    _this.showReport("exercise", false);
                }
            });
            /*if (!this.practice.currentCase) {
                this.showReport("quiz", false);
            }*/
        });
        //this.practice = this.getMockPractice();
    };
    CasePracticeCoachComponent.prototype.getPracticeByPracticeMetaId = function () {
        var _this = this;
        this.apiService.getPracticeByMetaId("" + this.practiceMetaId + "").subscribe(function (practice) {
            _this.practice = practice;
            _this.practiceId = _this.practice.id;
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/getUserInfo',
                'data': {}
            }).subscribe(function (result) {
                _this.status = result;
                if (!_this.practice.currentCase && _this.status == 1 || _this.status != 1 && _this.practice.progress >= 49 && _this.practice.progress <= 51) {
                    _this.showReport("exercise", false);
                }
                else if (_this.practice.status == 0) {
                    _this.page = "begin";
                }
                else {
                    _this.page = "main";
                }
            });
            /*if (!this.practice.currentCase) {
                this.showReport("quiz", false);
            }
            else if (this.practice.status == 0) {
                this.page = "begin";
            }
            else {
                this.page = "main";
            }*/
        });
    };
    CasePracticeCoachComponent.prototype.begin = function () {
        this.page = "main";
        if (!this.isSeperateModel) {
            this.createPractice();
        }
        else {
            this.apiService.updatePracticeStatus("" + this.practice.id + "").subscribe(function (result) { });
        }
    };
    CasePracticeCoachComponent.prototype.showReport = function (caseType, firstEntry) {
        var caseId = this.practice.currentCase && this.status == 1 ? this.practice.currentCase.id : 0;
        var link = ['practice-report', this.practiceId, caseType, caseId, this.isSeperateModel ? 1 : 0, firstEntry ? 1 : 0, this.learningPathId];
        this.router.navigate(link);
    };
    CasePracticeCoachComponent.prototype.linkToReport = function (id) {
        var link = ['case-practice-report-new', this.practiceId, id, this.learningPathId];
        this.router.navigate(link);
    };
    CasePracticeCoachComponent.prototype.exit = function (param) {
        /*if (this.isSeperateModel) {
            wx.closeWindow();
        }
        else {
            this.apiService.ajax({
                'type': 'get',
                'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
            }).subscribe(result=>{
                let link = ['learning-path',result];
                this.router.navigate(link);
            });
        }*/
        this.page = 'list';
    };
    CasePracticeCoachComponent.prototype.getMockData = function () {
        return { "id": 1955, "exercise": [{ "id": 2253, "title": "\u62a5\u544a\u8fdf\u4ea4\uff0c\u8c01\u4e4b\u8fc7?", "description": "\u4e00\u4e2a\u52e4\u594b\u4f46\u73bb\u7483\u5fc3\u7684\u5458\u5de5\u7531\u4e8e\u8fdf\u4ea4\u62a5\u544a\u5f15\u53d1\u7684\u4e00\u7cfb\u5217\u7684\u6545\u4e8b", "status": 1 }, { "id": 2254, "title": "\u5458\u5de5\u60c5\u7eea\uff0c\u5982\u4f55\u5316\u8d1f\u4e3a\u6b63", "description": "\u5982\u4f55\u8f85\u5bfc\u4e00\u4e2a\u5e26\u6709\u8d1f\u9762\u60c5\u7eea\u7684\u8001\u5458\u5de5\uff1f\u8fd9\u662f\u4e2a\u5e38\u89c1\u7684\u95ee\u9898\uff0c\u8981\u600e\u4e48\u505a\u5462\uff1f", "status": 1 }] };
    };
    CasePracticeCoachComponent.prototype.getMockPractice = function () {
        return {
            "id": 4,
            "currentCase": {
                "id": 7,
                "name": "小练习1",
                "description": "<p>小吕是你最近招的新员工，是一位90后，刚刚入职一个月。你对小吕这一个月的工作表现不是很满意。</p><p>小吕平时沉默寡言，经常上班迟到。比如上周的5天，他就迟到了3天。</p><p>因为小吕是新员工，所以按照惯例，你请他写一份简短的自我介绍。用来在第一次开会时向其他同事介绍自己。原本小吕满口答应，但却在约定好的时间当天交不出来。当你问他为何没有写自我介绍时，他表示因为没有得个参考模板，自已不知道应该怎么写。</p><p>你决定对小吕进行一次辅导。</p>",
                "type": null,
                "guide": "你好啊，小吕，最近怎么样啊？",
                "response": "挺好的啊，其实最近工作特别忙，但是感觉很充实。挺好的啊，其实最近工作特别忙，但是感觉很充实。",
                "startDescription": "寒暄过后，你切入正题，开始和小吕探讨他近期的工作表现",
                "status": 1,
                "startTime": "2017-12-08 22:51:13",
                "questions": [
                    {
                        "id": 1,
                        "description": "问题1",
                        "type": 1,
                        "options": [
                            {
                                "id": 1,
                                "point": 1,
                                "description": "你上周出现了连续几次迟到，能不能和我解释一下是什么原因？",
                                "selected": false,
                                "feedbackRank": 1,
                                "feedbackTitle": "这不是最好的问题",
                                "feedbackDescription": "你在还没有了解背后的原因之前，你太早使用了提问引导的技巧，这并不是最恰当时机，容易造成误会和抵触情绪。",
                                "response": "其实家里出了点事情，已经解决了。"
                            },
                            {
                                "id": 2,
                                "point": 2,
                                "description": "你知不知道经常迟到会造成什么不好的影响？",
                                "selected": false,
                                "feedbackRank": 1,
                                "feedbackTitle": "这不是最好的问题",
                                "feedbackDescription": "你在还没有了解背后的原因之前，你太早使用了提问引导的技巧，这并不是最恰当时机，容易造成误会和抵触情绪。",
                                "response": "其实家里出了点事情，已经解决了。"
                            },
                            {
                                "id": 3,
                                "point": 3,
                                "description": "你最近经常迟到造成了很不好的影响，你能否保证自己下周开始不再迟到？",
                                "selected": false,
                                "feedbackRank": 1,
                                "feedbackTitle": "这不是最好的问题",
                                "feedbackDescription": "你在还没有了解背后的原因之前，你太早使用了提问引导的技巧，这并不是最恰当时机，容易造成误会和抵触情绪。",
                                "response": "其实家里出了点事情，已经解决了。"
                            },
                            {
                                "id": 4,
                                "point": 4,
                                "description": "上班迟到是很不应该发生的问题，你能不能和我解释一下这几天连续迟到是什么原因？",
                                "selected": false,
                                "feedbackRank": 5,
                                "feedbackTitle": "非常好",
                                "feedbackDescription": "非常好!这是一个标准的开放式澄清问题。你可以通过这个问题挖掘出下属迟到现象背后的原因",
                                "response": "其实家里出了点事情，已经解决了。"
                            }
                        ]
                    }
                ]
            },
            "caseType": "quiz",
            "progress": "0.00",
            "status": 0,
            "nextExerciseStartTime": null,
            "headImageUrl": ""
        };
    };
    return CasePracticeCoachComponent;
}());
export { CasePracticeCoachComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-coach/case-practice-coach.component.ts.pre-build-optimizer.js